import React, { useEffect, useState } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Home from "./components/home/home";
import Profile from "./components/profile/profile";
import RemoteControl from "./components/web-remote-controller/remote-control/remote-control";
import Topic from "./components/topic/Topic";
import ApiTesterPage from "./components/api-tester/api-tester";
import AiChat from "./components/ai-chat/ai-chat";
import Loading from "./components/Loading/Loading";
import MCPBlogPage from "./components/mcp-blog/mcp-blog";
import config from "./config/config.json";

// Page transition wrapper
const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.4, ease: "easeInOut" }}
  >
    {children}
  </motion.div>
);

function App() {
  const { pathname } = useLocation();
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [theme, setTheme] = useState(
    () => localStorage.getItem("app-theme") || "light"
  );

  const toggleAIChat = () => setIsAIChatOpen((p) => !p);
  const openAIChat   = () => setIsAIChatOpen(true);

  const toggleTheme = () => {
    setTheme(prev => {
      const next = prev === "dark" ? "light" : "dark";
      localStorage.setItem("app-theme", next);
      return next;
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const isRemoteControl = pathname === "/web-remote-control";
    if (isRemoteControl) {
      document.body.removeAttribute("data-theme");
    } else {
      document.body.setAttribute("data-theme", theme);
    }
  }, [theme, pathname]);

  useEffect(() => {
    const triggerServers = async () => {
      try {
        const [a, s] = await Promise.all([
          fetch(`${config.apiTesterURL}/`, { method: "GET", headers: { "Content-Type": "application/json" } }),
          fetch(`${config.socketURL}/`,    { method: "GET", headers: { "Content-Type": "application/json" } }),
        ]);
        const [aData, sData] = await Promise.all([a.json(), s.json()]);
        console.log(aData.message, sData.message);
      } catch (_) {}
    };
    triggerServers();
  }, []);

  const handleLoadingComplete = () => setIsLoading(false);

  return (
    <>
      <AnimatePresence>
        {isLoading && <Loading onComplete={handleLoadingComplete} />}
      </AnimatePresence>
      {!isLoading && (
        <>
          <AnimatePresence mode="wait">
            <Routes location={{ pathname }} key={pathname}>
              <Route
                path="/"
                element={
                  <PageWrapper>
                    <Home
                      currentPage="home"
                      isAIChatOpen={isAIChatOpen}
                      openAIChat={openAIChat}
                      theme={theme}
                      toggleTheme={toggleTheme}
                    />
                  </PageWrapper>
                }
              />
              <Route
                index
                element={
                  <PageWrapper>
                    <Home
                      currentPage="home"
                      isAIChatOpen={isAIChatOpen}
                      openAIChat={openAIChat}
                      theme={theme}
                      toggleTheme={toggleTheme}
                    />
                  </PageWrapper>
                }
              />
              <Route
                path="/developer"
                element={
                  <PageWrapper>
                    <Profile
                      currentPage="developer"
                      isAIChatOpen={isAIChatOpen}
                      openAIChat={openAIChat}
                      theme={theme}
                      toggleTheme={toggleTheme}
                    />
                  </PageWrapper>
                }
              />
              <Route
                path="/mcp-blog"
                element={
                  <PageWrapper>
                    <MCPBlogPage
                      currentPage="mcp"
                      theme={theme}
                      toggleTheme={toggleTheme}
                      isAIChatOpen={isAIChatOpen}
                      openAIChat={openAIChat}
                    />
                  </PageWrapper>
                }
              />
              <Route
                path="/api-tester"
                element={
                  <PageWrapper>
                    <ApiTesterPage
                      currentPage="api"
                      theme={theme}
                      toggleTheme={toggleTheme}
                      isAIChatOpen={isAIChatOpen}
                      openAIChat={openAIChat}
                    />
                  </PageWrapper>
                }
              />
              <Route path="/web-remote-control" element={<RemoteControl />} />
              <Route path="/topic" element={<Topic />} />
              <Route
                path="*"
                element={
                  <PageWrapper>
                    <Home
                      currentPage="home"
                      isAIChatOpen={isAIChatOpen}
                      openAIChat={openAIChat}
                      theme={theme}
                      toggleTheme={toggleTheme}
                    />
                  </PageWrapper>
                }
              />
            </Routes>
          </AnimatePresence>
          <AiChat isAIChatOpen={isAIChatOpen} toggleAIChat={toggleAIChat} />
        </>
      )}
    </>
  );
}

export default App;
